document.addEventListener("DOMContentLoaded", function () {
  const filterDetails = document.querySelectorAll(".ck-js-filters");
  let activeFilter = null;

  // Function to close all filters
  function closeAllFilters() {
    filterDetails.forEach((detail) => {
      detail.setAttribute("aria-expanded", "false");
      detail.removeAttribute("open");
    });
    activeFilter = null;
  }

  // Handle click on filter details
  filterDetails.forEach((detail) => {
    const summary = detail.querySelector("summary");

    summary.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const isExpanded = detail.getAttribute("aria-expanded") === "true";

      // If clicking the same filter that's already open, close it
      if (isExpanded && activeFilter === detail) {
        closeAllFilters();
        return;
      }

      // Close all filters first
      closeAllFilters();

      // Open the clicked filter
      detail.setAttribute("aria-expanded", "true");
      detail.setAttribute("open", "");
      activeFilter = detail;
    });
  });

  // Handle click outside to close
  document.addEventListener("click", function (e) {
    // Don't close if clicking inside the active filter's content
    if (activeFilter && activeFilter.contains(e.target)) {
      return;
    }

    // Close if clicking anywhere else
    closeAllFilters();
  });

  // Prevent clicks inside the filter content from closing it
  filterDetails.forEach((detail) => {
    const content = detail.querySelector("ul");
    if (content) {
      content.addEventListener("click", function (e) {
        e.stopPropagation();
      });
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  // Check if we're on desktop (you can fine-tune this breakpoint)
  if (window.innerWidth > 768) {
    const ckFilterStyles = document.getElementById("ck-filter-styles");
    if (ckFilterStyles) {
      ckFilterStyles.remove();
      console.log("🧹 Removed #ck-filter-styles for desktop");
    }
  }
});

function bindLabelToggleBehavior() {
  document
    .querySelectorAll("#ck-filter-styles .facet-checkbox.facet-toggle")
    .forEach((label) => {
      label.addEventListener("click", () => {
        const input = label.querySelector("input[type='checkbox']");
        if (!input) return;

        requestAnimationFrame(() => {
          if (input.checked) {
            input.removeAttribute("checked");
            input.checked = false;
          } else {
            input.setAttribute("checked", "checked");
            input.checked = true;
          }
        });
      });
    });
}

function isMobileViewport() {
  return window.innerWidth <= 768;
}

document.addEventListener("click", (event) => {
  const facetRemoveLink = event.target.closest(
    "facet-remove a.active-facets__button"
  );

  if (!facetRemoveLink) return;

  const labelText = facetRemoveLink.textContent.trim();

  const isClearAll = facetRemoveLink.classList.contains(
    "active-facets__button--dark"
  );
  setTimeout(() => {
    console.log(isMobileViewport());
    if (isMobileViewport()) {
      if (isClearAll) {
        document
          .querySelectorAll("#ck-filter-styles input[type='checkbox']")
          .forEach((input) => {
            input.checked = false;
            input.removeAttribute("checked");
          });
      } else {
        const value = labelText.split(":")[1]?.trim();
        if (!value) return;

        const matchingInput = Array.from(
          document.querySelectorAll("#ck-filter-styles input[type='checkbox']")
        ).find((input) => input.value === value);

        if (matchingInput) {
          matchingInput.checked = false;
          matchingInput.removeAttribute("checked");
        }
      }
    }
  }, 100);
});

bindLabelToggleBehavior();
